module.exports = __webpack_public_path__ + "media/images/profile/more-menu-icon-890bc3e04a5c263ba8163f822bcec1bd.svg";